import { Roles } from 'interfaces/groups';
import { useGetRequest } from './../utils/useGetRequest';

const useGetAllRoles = () => {
  const [{ data, error, loading: isLoading }] = useGetRequest<Roles>({
    path: `v1/roles?size=100`, useRouteIssuer: true
  });

  return {
    roles: data?.data,
    isLoading,
    isError: error,
  };
};

export default useGetAllRoles;
